import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import PODetails from './PODetails';
import EditFieldModal from './table/EditFieldModal';
import { usePOTemplateOrderState } from './AddPOTemplateProvider';
import LeftSideSection from './LeftSideSection';
import DragDropSort from '../../../Components/DragDropSort/DragDropSort';

function AddEditPOTemplate() {
  const { poTemplateState, handleSave, changeData, redirectToListingPage, setPOTemplateState } = usePOTemplateOrderState();
  const { leftColumn } = poTemplateState;
  const { t } = useTranslation('common');

  const handleShowRearrangeModal = () => {
    setPOTemplateState((otherState) => ({
      ...otherState,
      reArrange: !poTemplateState.reArrange,
    }));
  };

  const handleSaveSequence = async (_e, sequenceList) => {
    const rCol = poTemplateState?.rigthColumn;
    rCol.templateJsonSchema = sequenceList?.sequence;
    setPOTemplateState((oldEle) => ({
      ...oldEle,
      rigthColumn: rCol,
    }));
    handleShowRearrangeModal();
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('ADD_PO_TEMPLATE_PROVIDER.CREATE_PO')}</h4>
        </div>
        <div className="search-filter">
          <button
            className="show-button ml-1"
            type="button"
            name="Rearrange"
            title={t('ADD_PO_TEMPLATE_PROVIDER.REARRANGE')}
            onClick={handleShowRearrangeModal}
          >
            <i className="icon-expand m-1" />
          </button>
          <button className="show-button d-none d-md-block ml-1" type="button" name="Save" title={t('ADD_PO_TEMPLATE_PROVIDER.SAVE')} onClick={handleSave}>
            {t('SPEC_TEMP_LIBRARY.SAVE')}
          </button>
          <button
            className="filter-btn d-md-none ml-1"
            type="button"
            name="Save"
            title={t('ADD_PO_TEMPLATE_PROVIDER.SAVE')}
            // onClick={handleSave}
          >
            <i className="icon-Save f-16" />
          </button>
          <button className="show-button ml-1" type="button" name="Cancle" title={t('ADD_PO_TEMPLATE_PROVIDER.CANCEL')} onClick={redirectToListingPage}>
            {t('COMMON_LABEL.CANCEL')}
          </button>
        </div>
      </div>
      <Container fluid className="position-relative h-100 overflow-hidden">
        <DndProvider backend={HTML5Backend}>
          <Row className="h-100">
            <Col lg={2} className="border-right color-dark px-0">
              <LeftSideSection leftColumn={leftColumn} />
            </Col>
            <Col className="pt-3" lg={10} style={{ maxHeight: '100%', overflow: 'auto' }}>
              <PODetails fromForm />
            </Col>
          </Row>
        </DndProvider>
        {poTemplateState.editPopup && (
          <EditFieldModal
            data={poTemplateState?.editpopupChildData ? poTemplateState?.editpopupChildData : poTemplateState?.editpopupData}
            dataIndex={poTemplateState?.editPopupIndex}
            submit={changeData}
          />
        )}
        {poTemplateState.reArrange && (
          <DragDropSort
            isShow={poTemplateState.reArrange}
            isToggle={handleShowRearrangeModal}
            fromComp="POTemplate"
            itemList={poTemplateState.rigthColumn?.templateJsonSchema}
            saveSequence={handleSaveSequence}
          />
        )}
      </Container>
    </>
  );
}

export default AddEditPOTemplate;
